import {errorHandler} from '@utilities/helpers.ts'
import {useEffect} from 'react'
import {useChatbotStore} from '@features/chatbot/store/chatbotStore.ts'
import {CHATBOT_SOURCES} from '@features/chatbot/types.ts'
import {useTranslation} from 'react-i18next'
import {useAuthStore} from '@features/user/store/store.ts'
import axios from '@/axiosInstance.ts'

interface SendReminderProps {
    flowSource: string
}

const httpSendReminder = (accessToken: string, entityId: number, media: number) => {
    const url = `/chatbot/entities/${entityId}/${media}/sendReminder`
    return axios.get(url, {headers: {Authorization: `Bearer ${accessToken}`}})
}

export function SendReminder({flowSource}: SendReminderProps) {
    const {t} = useTranslation()
    const accessToken = useAuthStore(store => store.accessToken)
    const selectedShoot = useChatbotStore(store => store.selectedAssignment)
    const addStepToHistory = useChatbotStore(store => store.addStepToHistory)

    useEffect(() => {
        onSendReminderResults()
    }, [])

    const onSendReminderResults = async () => {
        if (!accessToken || !selectedShoot?.quote) {
            console.error('Missing required data for sending reminder')
            return
        }

        try {
            const entityId = selectedShoot.entity.external_id
            const shootMediaId = selectedShoot.task_media.id

            await httpSendReminder(accessToken, Number(entityId), Number(shootMediaId))
            addStepToHistory({
                id: flowSource,
                source: CHATBOT_SOURCES.CHATBOT,
                text: "[Reminder sent] Awesome, we just emailed the host. Please get back to us if you don't hear from them within the next 10 days."
            })
        } catch (e) {
            errorHandler(e)
            addStepToHistory({
                id: flowSource,
                source: CHATBOT_SOURCES.CHATBOT,
                text: "[Reminder sent error] Awesome, we just emailed the host. Please get back to us if you don't hear from them within the next 10 days."
            })
        }
    }

    return <p>{t('chatbot:send_reminder:send_reminder_confirm')}</p>
}
